import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio.jsx";
import Cashflow from "./pages/Cashflow.jsx";
import Monopoly from "./pages/Monopoly.jsx";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/cashflow" element={<Cashflow />} />
        <Route path="/monopoly" element={<Monopoly />} />
      </Routes>
    </Router>
  );
}
